module.exports = __webpack_public_path__ + "ptc_momoro_H2.bf867342.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/momoro/parent_to_child/ptc_momoro_H2.jpg
// module id = 2FkF
// module chunks = 0